<template>
    <div>
        <fullscreen-drawer
            v-if="featureFlags['live-site-responsive-design']"
            :visible="visible && !forceHide"
            @close="handleClose"
        >
            <div class="drawer-content g-pt-10">
                <div class="grin-logo g-mb-4">
                    <powered-by-grin :hide-links="true" />
                </div>
                <div class="g-mb-6">
                    <g-typography
                        class="poll-prompt"
                        tag="h1"
                        font-weight="semibold"
                        size="h1"
                        style="text-align: center"
                    >
                        How easy was it to set up your payouts?
                    </g-typography>
                </div>
                <g-row class="poll-options-row" type="flex" justify="center">
                    <g-column v-for="option in ONBOARDING_POLL_OPTIONS" :key="option.value">
                        <div class="poll-option-container" @click="handleSubmit(option.value)">
                            <img class="poll-option-image g-mx-3" :src="option.icon" :alt="option.value" />
                        </div>
                    </g-column>
                </g-row>
                <div class="label-container g-pt-3">
                    <div class="difficult-label g-ml-3">Very Difficult</div>
                    <div class="easy-label">Very Easy</div>
                </div>
            </div>
        </fullscreen-drawer>
        <g-drawer
            v-else
            :visible="visible && !forceHide"
            height="100%"
            get-container="#app"
            placement="bottom"
            class="OnboardingPollDrawer"
            @close="handleClose"
        >
            <div class="drawer-content g-pt-10">
                <div class="grin-logo g-mb-4">
                    <powered-by-grin :hide-links="true" />
                </div>
                <div class="g-mb-6">
                    <g-typography
                        class="poll-prompt"
                        tag="h1"
                        font-weight="semibold"
                        size="h1"
                        style="text-align: center"
                    >
                        How easy was it to set up your payouts?
                    </g-typography>
                </div>
                <g-row class="poll-options-row" type="flex" justify="center">
                    <g-column v-for="option in ONBOARDING_POLL_OPTIONS" :key="option.value">
                        <div class="poll-option-container" @click="handleSubmit(option.value)">
                            <img class="poll-option-image g-mx-3" :src="option.icon" :alt="option.value" />
                        </div>
                    </g-column>
                </g-row>
                <div class="label-container g-pt-3">
                    <div class="difficult-label g-ml-3">Very Difficult</div>
                    <div class="easy-label">Very Easy</div>
                </div>
            </div>
        </g-drawer>
    </div>
</template>

<script>
    import { ref } from 'vue-demi';
    import { ONBOARDING_POLL_OPTIONS } from '../../../../../app-v2/constants/polls';
    import useEventTracking from '../../../../composables/use-event-tracking';
    import useOnboarding from '../../../../composables/use-onboarding';
    import { EVENT_NAME_ONBOARDING_POLL_SUBMITTED } from '../../../../../app-v2/constants/analytics-events';
    import useContactStore from '../../../../../stores/contact';
    import { message } from '@grininc/grin-ui';
    import { useFeatureFlagsStore } from '../../../../../stores';
    import FullscreenDrawer from '../../../../../app-v2/components/library/FullscreenDrawer.vue';

    export default {
        name: 'OnboardingPollDrawer',
        components: { FullscreenDrawer },
        props: {
            visible: {
                type: Boolean,
                default: false
            }
        },

        setup(props, context) {
            const events = useEventTracking();
            const onboarding = useOnboarding();
            const contactStore = useContactStore();
            const contact = contactStore.data;
            const featureFlags = useFeatureFlagsStore().data;

            //since we don't want to make the user wait for api calls to close the drawer
            const forceHide = ref(false);

            const handleClose = async () => {
                forceHide.value = true;

                await onboarding.hideOnboardingPoll(contact.id);
                context.emit('refresh-payout-account');
            };

            const handleSubmit = async (val) => {
                forceHide.value = true;

                await onboarding.hideOnboardingPoll(contact.id);

                events.trackEvent(EVENT_NAME_ONBOARDING_POLL_SUBMITTED, {
                    contact_id: contact.id,
                    survey_results: val
                });

                context.emit('refresh-payout-account');

                message.success('Thank you for your feedback!');
            };

            return {
                forceHide,
                handleClose,
                handleSubmit,
                ONBOARDING_POLL_OPTIONS,
                featureFlags,
            };
        }
    };
</script>

<style lang="scss" scoped>
    @media only screen and (max-width: 480px) {
        ::v-deep .ant-drawer-wrapper-body {
            height: 100vh;
            display: flex;
            flex-flow: column;
            justify-content: center;
        }
        .poll-option-container {
            .poll-option-image {
                width: 53px !important;
                @media only screen and (max-width: 335px) {
                    width: 45px !important;
                }
            }
        }
        .label-container {
            max-width: 336px !important;
            @media only screen and (max-width: 335px) {
                max-width: 279px !important;
            }
        }
    }
    .grin-logo {
        text-align: center;
    }

    .poll-prompt {
        max-width: 300px;
        margin: 0 auto;
    }

    .poll-options-row {
        flex-wrap: nowrap;
        .poll-option-container {
            cursor: pointer;

            .poll-option-image {
                flex-shrink: 1;
                width: 60px;
            }
        }
    }

    .label-container {
        max-width: 380px;
        margin: 0 auto;
        .difficult-label {
            float: left;
        }

        .easy-label {
            margin-right: 0.5rem;
            float: right;
            @media only screen and (max-width: 480px) {
                margin-right: 0px;
            }
        }
    }
</style>
